<app-keys></app-keys>
<mat-toolbar class="flex items-center justify-between" style="min-height: 30px; max-height: 30px;">
  <span class="text-xs pr-4">Oregon Health Authority</span>
  <span class="text-xs pr-4">Public Health Division</span>
  <span class="text-xs pr-4">Laboratory Quality Assurance (&copy; 2025)</span>
  <span class="text-xs">{{environment.build}} Version {{environment.version}}</span>
  <span class="flex-1"></span> 
</mat-toolbar>